import { render, staticRenderFns } from "./Reclamos.vue?vue&type=template&id=e0507734&"
import script from "./Reclamos.vue?vue&type=script&lang=js&"
export * from "./Reclamos.vue?vue&type=script&lang=js&"
import style0 from "./Reclamos.vue?vue&type=style&index=0&id=e0507734&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports